import firebase from 'firebase/app';
import 'firebase/analytics';

import { firebaseConfig } from './config';

firebase.initializeApp(firebaseConfig);

export const analytics = firebase.analytics();
